import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/number/is-nan';
import { AuthenticationContext } from 'react-adal';
import { runWithAdal } from 'react-adal';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import * as RJRTConfigVars from './config';

//this is a temporary var you can change to true to stop the app from requiring you to login
//this should NOT be used to create the public version of the app.  That is created
//using an environment variable in the build step
const DO_NOT_LOGIN = false;

//set the authContext (which includes the Azure config) based on the environment
let authContext = (process.env.NODE_ENV === 'development') ? new AuthenticationContext(RJRTConfigVars.RJRTADALConfigDev) : new AuthenticationContext(RJRTConfigVars.RJRTADALConfigProd);

if (process.env.REACT_APP_ISSECURE === 'true') {
  //if the ISSECURE flag is set, then wrap the entire app in the authentication call (this secures the entire App as opposed to just securing certain routes)
    runWithAdal(authContext, () => {
      ReactDOM.render(
        <App />,
        document.getElementById('root')
      );
    },DO_NOT_LOGIN);

} else {
    // if the app is public, then just render out the app component
    ReactDOM.render(
      <App />,
      document.getElementById('root')
    );
}








// WEBPACK FOOTER //
// ./src/index.js